import React, { useEffect, useState } from 'react';
import { useGenericCRUD } from '@/hooks/useGenericCRUD';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { toast } from '@/components/ui/use-toast';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ChevronDown, ChevronUp } from 'lucide-react';

const FaqItem = ({ title, content }) => {
  const [open, setOpen] = useState(false);
  return (
    <Card className="mb-4 hover:border-[#FCD34D] border-[#3B6BA8] transition-all duration-300 cursor-pointer bg-[#FFFFFF]" onClick={() => setOpen(!open)}>
      <CardHeader className="p-4 pb-4 border-b border-[#3B6BA8]/10">
        <div className="flex w-full justify-between items-center">
          <CardTitle className="text-lg font-bold text-[#3B6BA8]">{title}</CardTitle>
          {open ? <ChevronUp className="h-5 w-5 text-[#FCD34D]" /> : <ChevronDown className="h-5 w-5 text-[#3B6BA8]" />}
        </div>
      </CardHeader>
      {open && (
        <CardContent className="p-4 pt-4 text-[#1F2937]">
          <div className="font-medium">
            {content}
          </div>
        </CardContent>
      )}
    </Card>
  );
};

export default function AjudaPage() {
  const { data: faqs, fetchAll: fetchFAQs } = useGenericCRUD('sys_faqs');
  const { create: submitContact } = useGenericCRUD('sys_contatos_suporte');
  const [contactForm, setContactForm] = useState({ nome: '', email: '', assunto: '', mensagem: '' });

  useEffect(() => { fetchFAQs(); }, [fetchFAQs]);

  const handleContactSubmit = async (e) => {
    e.preventDefault();
    try {
      await submitContact(contactForm);
      toast({ title: 'Mensagem Enviada!', description: 'Nossa equipe entrará em contato em breve.' });
      setContactForm({ nome: '', email: '', assunto: '', mensagem: '' });
    } catch (err) {
      toast({ title: 'Erro', description: 'Não foi possível enviar a mensagem.', variant: 'destructive' });
    }
  };

  return (
    <div className="space-y-6 bg-[#FFFFFF] min-h-screen p-6">
      <div className="bg-[#FFFFFF] border border-[#3B6BA8] rounded-lg shadow-md p-6">
        <h1 className="text-2xl font-bold text-[#3B6BA8] mb-6 border-b-2 border-[#3B6BA8] pb-4">Central de Ajuda (FAQ)</h1>
        <div className="max-w-3xl">
          {faqs.length > 0 ? faqs.map(faq => (
            <FaqItem key={faq.id} title={faq.pergunta} content={faq.resposta} />
          )) : (
            <Card className="border-[#3B6BA8]">
              <CardContent className="p-6 text-center text-gray-500 font-bold">
                Nenhuma pergunta cadastrada no momento.
              </CardContent>
            </Card>
          )}
        </div>
      </div>

      <div className="bg-[#FFFFFF] border border-[#3B6BA8] rounded-lg shadow-md p-6">
        <h2 className="text-xl font-bold text-[#3B6BA8] mb-6 border-b-2 border-[#3B6BA8] pb-4">Contato de Suporte</h2>
        <form onSubmit={handleContactSubmit} className="space-y-4 max-w-xl">
          <Input className="border-[#3B6BA8]" required placeholder="Seu Nome" value={contactForm.nome} onChange={e => setContactForm({...contactForm, nome: e.target.value})} />
          <Input className="border-[#3B6BA8]" required type="email" placeholder="Seu E-mail" value={contactForm.email} onChange={e => setContactForm({...contactForm, email: e.target.value})} />
          <Input className="border-[#3B6BA8]" required placeholder="Assunto" value={contactForm.assunto} onChange={e => setContactForm({...contactForm, assunto: e.target.value})} />
          <Textarea required placeholder="Sua Mensagem..." value={contactForm.mensagem} onChange={e => setContactForm({...contactForm, mensagem: e.target.value})} className="h-32 border-[#3B6BA8] focus-visible:ring-[#FCD34D]" />
          <Button type="submit" className="w-full">Enviar Mensagem</Button>
        </form>
      </div>
    </div>
  );
}